import { ReactNode } from 'react';
import { InputNumberProps } from 'antd/lib/input-number';

/**
 * InputNumber组件限制props
 * @param numberLength 数字最大长度（小数点除外）
 * @param decimalLength 小数部分长度
 * @returns InputNumberProps
 */
export function decimalInputNumber(
  numberLength: number,
  decimalLength: number = 2,
): InputNumberProps {
  const props: InputNumberProps = {
    min: 0,
    precision: decimalLength,
    maxLength: numberLength + 1,
  };
  const maxNumber: number = Number(
    '9'.padEnd(numberLength - decimalLength, '9'),
  );
  props.max = maxNumber;
  return props;
}
const selectFormItemType: string[] = [
  'Select',
  'SelectTable',
  'TreeSelect',
  'Switch',
  'DatePicker',
  'RangePicker',
  'TimePicker',
  'CheckboxGroup',
  'Checkbox',
  'Address',
  'RadioGroup',
  'SelectGroup',
  'AssociateSelect',
  'DropdownTable',
  'DropdownSyncTable',
  'SuperSelect',
  'SuperSelectTable',
  'SuperTransfer',
];
const uploadFormItemType: string[] = ['Upload', 'UploadImage', 'UploadImages'];
export function getRulesMessage(formItemType?: string, label?: ReactNode) {
  if (!formItemType) return '不能为空';
  if (selectFormItemType.includes(formItemType)) {
    return `请选择${label || ''}`;
  }
  if (uploadFormItemType.includes(formItemType)) {
    return `请上传${label || ''}`;
  }
  return `请输入${label || ''}`;
}

export function getInputPlaceholder(
  label?: ReactNode,
  props?: any,
  rules?: any[],
) {
  if (props?.placeholder) return props.placeholder;
  if (typeof label !== 'string') return '请输入';
  const isRequest = rules?.some?.(v => v.required);
  if (isRequest) return `请输入${label || ''}`;
  return label || '';
}

export function getSelectPlaceholder(
  label?: ReactNode,
  props?: any,
  rules?: any[],
) {
  if (props?.placeholder) return props.placeholder;
  if (typeof label !== 'string') return '请选择';
  const isRequest = rules?.some?.(v => v.required);
  if (isRequest) return `请选择${label || ''}`;
  return label || '';
}
